import i18n from 'utils/i18n'
import React from 'react';
import Text from "theme/Text";

const HomeOnboardingIndexScene = () => {
	
	return (
		<Text>{ i18n.t( 'ui.onboarding_web_unavailable' ) }</Text>
	)
}

export default HomeOnboardingIndexScene;
